const doc = [({"da":({"js":({"components":({"newsletter_time_zone_states":({"table":({"the_newsletter_template_time_zone_state_was_deleted":"Tidszonestatus blev slettet."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;